import { musicQueries, MusicGenre } from '@round/api';
import { ComboboxItem } from '@round/creatorbase-ui';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

const queryOptions = musicQueries.genres.options.listAll;

export type GenreItem = ComboboxItem<string>;

export const mapToItem = (genre: MusicGenre): GenreItem => ({
    value: genre.value,
    label: genre.label,
});

export function useSpotifyGenreCombobox() {
    const { data, isFetching, isError } = useQuery(queryOptions());
    const items = useMemo(() => data?.map(mapToItem) ?? [], [data]);

    return {
        items,
        isFetching,
        isError,
    };
}
